import {setWizardCloneLogic, setWizardList} from "../../wizardActions";
import {getFeatureExcludedIndex, getFeaturesExcludedObject, getWizardListWithHashes} from "../../wizardFunctions";
import {getApiConfig, getNextMaxNumberFromList} from "../../../../utilities";
import {showQuoteSavedNotification} from "../../../Generic/SuccessNotification";
import {getEnabledFeaturesFromResponse} from "../../../FeaturesSetup/featuresFunctions";
import {setData} from "../../../FeatureCreator/FeatureCreatorReducerNew";

/**
 * returns current wizard step section items
 * @param allSourceFeatures {array} // [{enabled, featureDefinitionId, featureName, groupName, id, sharedFeatureName}]
 * @param wizardGroups {[wizardGroupInterface]}
 * @param fromFabricatorId {number}
 * @param auth {object}
 * @returns {[]}
 */
const getNeededToCloneFeatures = async (allSourceFeatures = [], wizardGroups = [], fromFabricatorId, auth) => {
  const receivedGroups = {}; // {Backsplash: [],}
  let featuresToClone = [];
  for (let checkFeature of allSourceFeatures) {
    for (const wizardGroup of wizardGroups) {
      if (wizardGroup.groupName !== checkFeature.groupName) {
        continue;
      }
      if (wizardGroup.useIncluded) {
        if (wizardGroup.featuresIncluded.some(feature =>
          feature.featureDefinitionId === checkFeature.featureDefinitionId
          || feature.sharedFeatureName === checkFeature.sharedFeatureName)) {
          if (!featuresToClone.some(id => id === checkFeature.id)) {
            featuresToClone.push(checkFeature.id);
          }
        }
      } else if (wizardGroup.featuresExcluded && wizardGroup.featuresExcluded.length) {
        if (!receivedGroups[wizardGroup.groupName]) {
          const featuresResponse = await getApiConfig('wizard/features/').get(fromFabricatorId + "/" + wizardGroup.groupName);
          console.log("featuresResponse", featuresResponse);
          const {enabledFeatures} = setData({}, {enabledFeatures: featuresResponse, ...auth});
          receivedGroups[wizardGroup.groupName] = enabledFeatures;
        }
        if (receivedGroups[wizardGroup.groupName].some(feature =>
            feature.featureDefinitionId === checkFeature.featureDefinitionId
            || feature.sharedFeatureName === checkFeature.sharedFeatureName)
          && !wizardGroup.featuresExcluded.some(feature =>
            feature.featureDefinitionId === checkFeature.featureDefinitionId
            || feature.sharedFeatureName === checkFeature.sharedFeatureName)) {
          if (!featuresToClone.some(id => id === checkFeature.id)) {
            featuresToClone.push(checkFeature.id);
          }
        }
      } else if (checkFeature.enabled && !featuresToClone.some(id => id === checkFeature.id)) {
        featuresToClone.push(checkFeature.id);
      }
    }
  }
  console.log("featuresToClone", featuresToClone);
  return featuresToClone
}

export function cloneWizards(selectedWizards, selectedFabricators, mode, saveWizardList, getWizardList, abortablePromise) {
  console.log("selectedWizards before", selectedWizards, selectedFabricators, mode);

  return async (dispatch, getState) => {
    // loadingDialog_show(true, "Saving...", "Please wait while we are cloning selected wizards.");
    const store = getState();
    const {auth, asCustomer, wizardState, projectScopeNew} = store;
    const {masterFabricatorId} = auth;
    const fromFabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    const {featuresGroups} = projectScopeNew;


    const {wizardList, wizardVisualizer} = wizardState;
    const currentWizardList = wizardList.filter(wizardItem => wizardItem.visualizer === wizardVisualizer);

    //1) update current wizards with hashes (each wizard should have a uniqueHashId);
    dispatch(setWizardCloneLogic({visible: true, cloneStep: 1}));
    if (currentWizardList.some(wizard => !wizard.uniqueHashId)) {
      const updatedWizardList = getWizardListWithHashes(currentWizardList);
      await saveWizardList(currentWizardList, null, true); // update wizards with hashes on the backend
      dispatch(setWizardList(updatedWizardList.map(wizItem => Object.assign({}, wizItem)))); // update wizards with hashes on the frontend
      selectedWizards = updatedWizardList.filter(wizardItem => wizardItem.selected); // update current selected list with hashes
      console.log("selectedWizards after", selectedWizards);
    }

    //go ahead and clone
    for (const selectedFabricatorId of selectedFabricators) {

      dispatch(setWizardCloneLogic({toFabricator: selectedFabricatorId})); //2) get current fabricator wizard list
      await new Promise(resolve => setTimeout(resolve, 500));
      dispatch(setWizardCloneLogic({cloneStep: 2})); //2) get current fabricator wizard list
      let existingFabricatorWizards = await getWizardList(wizardVisualizer, selectedFabricatorId, true);
      if (!Array.isArray(existingFabricatorWizards)) {
        existingFabricatorWizards = []; // just in case
      }
      console.log("existingFabricatorWizards", existingFabricatorWizards);
      let newFabWizards = [...existingFabricatorWizards];

      for (const wizardItem of selectedWizards) {
        dispatch(setWizardCloneLogic({wizardName: wizardItem.name}));

        // it is a new wizard let's check if featureGroups are there // for every new wizard - new request
        await new Promise(resolve => setTimeout(resolve, 500));
        dispatch(setWizardCloneLogic({cloneStep: 3})); //3) get current fabricator feature groups
        abortablePromise = getApiConfig('ProjectScope');
        const currentFabFeatureGroups = await abortablePromise.get(`/features-groups/${selectedFabricatorId}/${masterFabricatorId}`);
        console.log("currentFabFeatureGroups", currentFabFeatureGroups);

        await new Promise(resolve => setTimeout(resolve, 500));
        dispatch(setWizardCloneLogic({cloneStep: 4})); //4) creating missing featureGroups

        const alreadyClonedWizardIndex = newFabWizards.findIndex(wizItem => wizItem.uniqueHashId === wizardItem.uniqueHashId)
        if (alreadyClonedWizardIndex > -1) {
          newFabWizards.splice(alreadyClonedWizardIndex, 1, Object.assign({}, wizardItem, {
            id: newFabWizards[alreadyClonedWizardIndex].id
          })); // here we keep old id (to keep structure), but update wizard with the new values
        } else {
          const nextId = getNextMaxNumberFromList(newFabWizards, "id");
          newFabWizards.push(Object.assign({}, wizardItem, {id: nextId}));

          //** missing feature groups start **//
          if (currentFabFeatureGroups && currentFabFeatureGroups.groups) {
            let missingGroups = [];
            const downloadedExistingGroups = []; /// {groupName: "", featuresFromFabricator: [], featuresToFabricator: []}
            for (const wizardGroup of wizardItem.wizardGroups) {
              const featureGroup = featuresGroups.find(fg => fg.groupName === wizardGroup.groupName);
              if (featureGroup) {
                const alreadyExistingFeatureGroup = currentFabFeatureGroups.groups.find(fg => fg.groupName === featureGroup.groupName);
                // what is going on here - if we are cloning feature group, but fabricator already has it, and some features
                // are enabled there - we need to add them to the excluded
                // added useIncluded, no more adding new features to excluded!!
                if (alreadyExistingFeatureGroup && !wizardGroup.useIncluded) {

                  dispatch(setWizardCloneLogic({cloneGroupName: alreadyExistingFeatureGroup.groupName}));

                  let alreadyDownloaded = downloadedExistingGroups.find(group => group.groupName === alreadyExistingFeatureGroup.groupName);
                  // we check if it was downloaded during the cloning process (same group several times)
                  if (!alreadyDownloaded) {
                    abortablePromise = getApiConfig('ProjectScope');

                    const featuresFromResponse = await abortablePromise.get(`/feature-group-features/${fromFabricatorId}/${masterFabricatorId}/0/${alreadyExistingFeatureGroup.groupName}`);
                    const featuresFromFabricator = getEnabledFeaturesFromResponse(featuresFromResponse, auth);

                    const featuresToResponse = await abortablePromise.get(`/feature-group-features/${selectedFabricatorId}/${masterFabricatorId}/0/${alreadyExistingFeatureGroup.groupName}`);
                    const featuresToFabricator = getEnabledFeaturesFromResponse(featuresToResponse, auth);

                    downloadedExistingGroups.push({groupName: alreadyExistingFeatureGroup.groupName, featuresToFabricator, featuresFromFabricator});
                    alreadyDownloaded = downloadedExistingGroups.find(group => group.groupName === alreadyExistingFeatureGroup.groupName);
                  }
                  console.log("wizardGroup.featuresExcluded before merge", wizardGroup.featuresExcluded);
                  console.log("alreadyDownloaded", alreadyDownloaded);
                  if (alreadyDownloaded) { // just in case
                    wizardGroup.featuresExcluded = [
                      ...wizardGroup.featuresExcluded,
                      ...alreadyDownloaded.featuresToFabricator
                        .filter(feature => {
                          return (getFeatureExcludedIndex(feature, wizardGroup.featuresExcluded) === -1) // not excluded already
                            && alreadyDownloaded.featuresFromFabricator.every(featureFrom => { // and not exist in from fabricator
                              return featureFrom.featureDefinitionId !== feature.featureDefinitionId
                                && featureFrom.sharedFeatureName !== feature.sharedFeatureName
                            })
                        })
                        .map(feature => getFeaturesExcludedObject(feature))
                    ];
                    console.log("new wizardGroup.featuresExcluded", wizardGroup.featuresExcluded);
                  }
                } else if (!missingGroups.some(fg => fg.groupName === featureGroup.groupName)) {
                  missingGroups.push(featureGroup);
                }
              }
            }
            dispatch(setWizardCloneLogic({cloneGroupName: ""}));
            dispatch(setWizardCloneLogic({cloneStep: 5}));
            console.log("missingGroups end", missingGroups);
            if (missingGroups.length) {
              abortablePromise = getApiConfig('ProjectScope');
              await abortablePromise.post(missingGroups, `/feature-groups-save/${selectedFabricatorId}`);
            }
          }
          //** missing feature groups end **//
        }
        //** missing features start **//
        await new Promise(resolve => setTimeout(resolve, 500));
        dispatch(setWizardCloneLogic({cloneStep: 6})); //6) creating missing features

        // 6.2) second we download all features and copy them to new fabricator
        abortablePromise = getApiConfig(`fabricators/${fromFabricatorId}/cloneFabricatorFeatures`);
        const cloneFeaturesResponse = await abortablePromise.get();

        if (cloneFeaturesResponse && cloneFeaturesResponse.features && cloneFeaturesResponse.features.length) {
          console.log("cloneFeaturesResponse", cloneFeaturesResponse);
          const featureIds = await getNeededToCloneFeatures(cloneFeaturesResponse.features, wizardItem.wizardGroups, fromFabricatorId, auth);
          const data = {
            featureIds,
            destinationFabricatorId: selectedFabricatorId,
            copyFeaturesType: "addNew"
          };
          abortablePromise = getApiConfig('fabricators/' + fromFabricatorId);
          const cloneResponse = await abortablePromise.post(data, `cloneFeatures?source=wizard&mode=${mode}`);
          console.log("cloneResponse", cloneResponse);
        }

        dispatch(setWizardCloneLogic({cloneStep: 7})); //6) cloning features
        //** missing features end **//
      }
      console.log("newFabWizards", newFabWizards);
      await saveWizardList(newFabWizards, selectedFabricatorId, true);
    }
    dispatch(setWizardCloneLogic({cloneStep: 8})); //5) show finished step
    // loadingDialog_show(false);
    await new Promise(resolve => setTimeout(resolve, 300));
    dispatch(setWizardCloneLogic({cloneStep: 9, finished: true})); //6) show finished step completed
    showQuoteSavedNotification("features.setup.footer.savedSuccess.title", "wizard.success.message.cloned");
    // dispatch(setWizardPopupOpened(false));
    // dispatch(setWizardPopupItem(defaultWizardItem)); // clear existing values
  }
}
